// Client-side react-table filter function for the column-menu `{ operator,
// values }` filter shape (AC-15498). Used as <DataTable>'s defaultColumn.filter
// so the AC-15377 column menu — originally server-only — also filters rows in
// the browser for clientSide tables. Case-insensitive, and coerces non-string
// cell values (arrays, numbers, null) to a searchable string so columns that
// hold lists/objects still filter sensibly.
//
// CASE SENSITIVITY (known cross-table difference, intentional): this client
// filter is case-INSENSITIVE for every operator (best UX). Server-mode tables
// only match the `contains` operator insensitively (the QueryableStringInvariant
// Contains handler in Host.cs); eq/neq/ncontains/in/nin go through HotChocolate's
// default handlers and are case-SENSITIVE on Postgres. We accept this: each
// table is internally consistent, and making the server uniformly insensitive
// would change the GLOBAL filter convention for every [UseFiltering] query.
//
// Inert unless a filter value is set, so columns/tables that never set one are
// unaffected.

function toText(value) {
  if (value === null || value === undefined) return "";
  if (Array.isArray(value)) return value.join(", ").toLowerCase();
  return String(value).toLowerCase();
}

export default function textColumnFilterFn(rows, columnIds, filterValue) {
  if (!filterValue || !filterValue.operator) return rows;

  const { operator, values = [] } = filterValue;
  const id = columnIds[0];
  const needles = values.map((v) => String(v).toLowerCase());
  const first = needles[0] ?? "";

  return rows.filter((row) => {
    const text = toText(row.values[id]);
    switch (operator) {
      case "eq":
        return text === first;
      case "neq":
        return text !== first;
      case "contains":
        return text.includes(first);
      case "ncontains":
        return !text.includes(first);
      case "empty":
        return text === "";
      case "nempty":
        return text !== "";
      case "in":
        return needles.includes(text);
      case "nin":
        return !needles.includes(text);
      default:
        return true;
    }
  });
}
